module.exports = __webpack_public_path__ + "static/img/four_06.0520bae.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/AtomicChain/assets/personalIntroduction/four_06.png
// module id = 1Xcr
// module chunks = 3